import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "app-tab" }
const _hoisted_2 = { class: "app-main" }
const _hoisted_3 = { class: "lay-side" }
const _hoisted_4 = { class: "lay-content" }

import zhCN from 'ant-design-vue/es/locale/zh_CN'
import {printWelcome} from "@/lib/util";
import dayjs from "dayjs";
import 'dayjs/locale/zh-cn'


export default /*#__PURE__*/_defineComponent({
  __name: 'MainLayout',
  setup(__props) {

dayjs.locale('zh-cn')
printWelcome()

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_component_a_config_provider, { locale: _unref(zhCN) }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_router_view, { name: "tabBar" })
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_view, { name: "side" })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_view)
        ])
      ])
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})